// Module
var code = "<nav aria-label=\"Page navigation\"> <ul data-bind=\"foreach: pages\" class=\"pagination\"> <li data-bind=\"css: { active: isActive }\"> <a href=\"#\" data-bind=\"click: $parent.changePage, text: text\"></a> </li> </ul> </nav>";
// Exports
export default code;